import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome,faAngleRight } from '@fortawesome/free-solid-svg-icons';
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';
import Courseschedule from '../Landing/Subcomponent/courseschedule';

class Leansix extends Component {
    render() {
        return (
            <div>
                <div arial-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <li class="breadcrumb-item"> <Link ><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                        </li>
                        <li class="breadcrumb-item active">Lean Six Sigma Supplement </li>
                    </ol>
                </div>
                <section class="course-header bg-lean11" id="course-header">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5" style={{// eslint-disable-next-line
                            backgroundImage: "url(" + "/assets/images/icons/six-sigma-bkg/six-sigma-symbol.svg" + ")",
                        }}>
                            <h1>Lean Six Sigma  <br /> Supplement </h1>
                            <br /> <br /> <br />
                            <div class="form-group">
                                <a href="#apply-nows" class="btn btn-md enroll-btn">Enroll Now </a>
                                <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                                    data-target="#myModal" onclick="return gtag_report_conversion('<?php echo $baseurl;?>course/lean-six-sigma-supplement');">Download
                        brochure</button>
                            </div>
                            <br /> <br /><h3 id="Description"> Online Live Training</h3><br /><br />
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-1"></div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                            <p>Certification jointly awarded by</p>
                            <ul>
                                <li><img alt="executive" width="" src="/assets/images/isi.svg" />  </li>
                                <li><img alt="executive" src="/assets/images/epn.svg" /></li>
                            </ul>
                            <br />
                        </div>
                    </div>
                </section>
                <div class="course-main-contains def-z">
                    <div class="card">
                        <div class="row contanint-display">
                            <div class="col-lg-6 col-xl-6 col-12 col-sm-12 col-md-6">
                                <b>Schedule: </b><br />
                            </div>
                            <div class="col-lg-6 col-xl-6 col-12 col-sm-12 col-md-6" >
                                <b> <i class="fa fa-calendar" ></i>&nbsp; Upto 3 Days</b><br />
                                <b>(Customisable as per requirements)</b>
                            </div>
                        </div>
                    </div>
                </div>
                <section class="def-z">
                    <div class="header" id="myHeader">
                        <ul>
                            <li><a href="#Description">Description</a></li>
                            <li><a href="#ValueAddition">Value Addition</a></li>
                            <li><a href="#Curriculum">Program Curriculum</a></li>
                            <li><a href="#Eligibility">Eligibility</a></li>
                            <li><a href="#Schedule">Course Schedule</a></li>
                            <li><a href="#Review-s">Learner Review </a></li>
                            <li><a href="#Certification-s">Certification</a></li>
                            <li class="btn-header cs-dx"><a href="#apply-nows">Enroll Now</a></li>
                        </ul>
                    </div>
                </section>
                <section class="course-description " id="course-description">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>About Lean Six Sigma Program</h3>
                            <p align="justify">A Lean Six Sigma training program helps an organization progressively, aggressively and incessantly reduce variability to reach to defect level below 3.4 ppm. In simpler terms, Six Sigma helps an organization achieve sustainable, predictable and desirable growth in profit for an organization.</p>
                            <p align="justify">Despite the defect reduction in the process, the possibility of “waste” remains. However, by implementing Lean there is a possibility of ruthlessly cutting down the waste and reducing defect levels. This will enable better flow in the process. While Lean is aimed at increasing speed, Six Sigma is concerned with defect reduction. When merged, Lean Six Sigma initiatives ensures accurate delivery at faster speed.</p>
                            <p align="justify">edu plus now’s Lean Six Sigma approach is focused towards ‘waste’ reduction with reduced defect level It follows a DMAIC approach</p>
                            <ul class="highlight-ul row ul-text" id="ValueAddition">
                                <div class="col-sm-6">
                                    <li>Define</li>
                                    <li >  Measure</li>
                                    <li>  Analyse</li>
                                </div>
                                <div class="col-sm-6">
                                    <li>Improve (To reduce waste in order to generate flow)</li>
                                    <li>Control (To sustain the flow)</li>
                                </div>
                            </ul>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-sm-12">
                            <h4>Value Addition</h4>
                            <h6>Our certified Lean Six Sigma (LSS) Black-Belt will have the following value addition:</h6>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table-highlight">
                                <tr> <td > <img alt="datascience10" src="/assets/images/icons/Group 2928.svg" />&nbsp;&nbsp;&nbsp;&nbsp;Create an impact in bringing conducive culture where defect reduction is encouraged in the lean process. <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; This is similar to encouraging high thinking in simple living</td> </tr>
                                <tr> <td id="Eligibility"> <img alt="datascience4" src="/assets/images/icons/Group 2942.svg" />&nbsp;&nbsp;&nbsp;&nbsp;Get Opportunity To Avail Offsite Project Assistance From Our Experts</td> </tr>
                                <tr> <td><img alt="datascience5" src="/assets/images/icons/Group 2920.svg" />&nbsp;&nbsp;&nbsp;&nbsp;Access To The Developments Of The LSS Community</td> </tr>
                                <tr> <td> <img alt="datascience6" src="/assets/images/icons/Group 3082.svg" />&nbsp;&nbsp;&nbsp;&nbsp;Obtain the knowledge resources in the areas of interest</td> </tr>
                            </table>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-sm-12" >
                            <h3>Who Should Enroll?</h3>
                            <h6 >The course is designed for Certified Six Sigma Black-Belts from the following areas:</h6>
                            <ul class="highlight-ul">
                                <li id="Curriculum">   Quality Assurance Engineers, Project Managers, Team leaders, Practitioners and Senior Management </li>
                                <li> Those who want to get certified as Lean Six Sigma Black Belt</li>
                                <li> Any other professional members who are engaged in research, innovation or consulting in process improvement practices</li>
                            </ul>
                        </div>
                    </div>
                </section>
                <section class="course-syllabus " id="course-syllabus">
                    <div class="row" >
                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10" >
                            <h3>Program Curriculum </h3>
                            <br />
                            <div class="syl-bg">
                                <h4>Introduction to LSS</h4>
                                <h6>Refreshing DMAIC</h6>
                                <div id="de_syllabus">
                                    <div class="panel-group">
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                                                href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                                }<a> Define Phase <i class="indicator fa fa-minus"></i></a>
                                                </h6>
                                            </div>
                                            <div id="de_syllabus1" class="collapse show" aria-labelledby="de_heading1"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li> Project Charter </li>
                                                        <li> BFC (SIPOC)</li>
                                                        <li>  AFC-DFC-OFC</li>
                                                        <li>  Current State-Value Stream Mapping (CS-VSM)</li>
                                                        <li> Routing card</li>
                                                        <li>  Spaghetti chart</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading2" data-toggle="collapse"
                                                href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                                }<a>Measure Phase <i class="indicator fa fa-plus"></i></a>
                                                </h6>
                                            </div>
                                            <div id="de_syllabus2" class="collapse " aria-labelledby="de_heading2"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>  Lean metrics</li>
                                                        <li>  Mapping metrics in CS-VSM</li>
                                                        <li>Work study method for collecting data</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading3" data-toggle="collapse"
                                                href="#de_syllabus3" aria-expanded="true" aria-controls="de_syllabus3">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                                } <a>Analyse Phase  <i class="indicator fa fa-plus"></i> </a>
                                                </h6>
                                            </div>
                                            <div id="de_syllabus3" class="collapse " aria-labelledby="de_heading3"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>  Types of waste</li>
                                                        <li>  Mapping type of waste in CS-VSM</li>
                                                        <li>  Identifying causes for the waste</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading4" data-toggle="collapse"
                                                href="#de_syllabus4" aria-expanded="true" aria-controls="de_syllabus4">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                                }<a>Improve Phase <i class="indicator fa fa-plus"></i> </a>
                                                </h6>
                                            </div>
                                            <div id="de_syllabus4" class="collapse " aria-labelledby="de_heading4"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>  Pull system-JIT-Kanban</li>
                                                        <li>  Haijunka Box</li>
                                                        <li>  Takt time and Line balancing</li>
                                                        <li>  Kaizen-Andon-Poka yoke-Jidokha-SMED</li>
                                                        <li>  TPM</li>
                                                        <li>  5-S</li>
                                                        <li>  Supermarket model</li>
                                                        <li >  Future State- VSM</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info" id="Schedule">
                                            <div class="panel-heading" id="de_heading5" data-toggle="collapse"
                                                href="#de_syllabus5" aria-expanded="true" aria-controls="de_syllabus5">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                                }<a>Control Phase  <i class="indicator fa fa-plus"></i>   </a>
                                                </h6>
                                            </div>
                                            <div id="de_syllabus5" class="collapse " aria-labelledby="de_heading5"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Report-out</li>
                                                        <li>  Cost benefit estimation</li>
                                                        <li>  Documentation</li>
                                                        <li>  Project closure</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Courseschedule />
                <Aboutuslearners />
                <Aluminicompany />
                <section class="course-learning-outcome bg-secondary1 " id="course-learning-outcome">
                    <div class="row">
                        <div class="col-sm-6">
                            <h3>Certification</h3>
                            <ul>
                                <li>ISI Pune in association with edu plus now will award participants a formal LSS Black-Belt Training Certificate on successful completion of this training (100% attendance) and clearing assessment ( <FontAwesomeIcon icon={faAngleRight} />= 70%).</li>
                            </ul>
                        </div>
                        <div class="col-sm-6">
                            <img alt="datascience18" src="/assets/images/icons/certificate-final.png" />
                            <p class="img-below-text text-center" id="apply-nows"><br />Awarded Jointly by The Indian Statistical Institute,<br />Pune and
                            edu plus now </p>
                        </div>
                    </div>
                    <br /><br />
                </section>
                <section class="courses-feesm">
                    <section class="course-fees" id="course-fees">
                        <div class="row box-sh" >
                            <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                            </div>
                            <div class="vertical-line-fee"> </div>

                            <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                                <div class="row">
                                    <div class="col-sm-10"> <br /><br />
                                        <h5>Features</h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 col-sm-12">
                                        <ul class="highlight-ss" >
                                            <li>  Excel functions </li>
                                            <li> Reports</li>
                                            <li>  Lookups  </li>
                                            <li>  Pivot tables  </li>
                                        </ul>
                                    </div>
                                    <p>{// eslint-disable-next-line
                                    }<marquee onmouseover="this.stop();" onmouseout="this.start();" class="marquee-enroll" >"If a group of four or more participants enroll with us, a concession of 10% will be awarded to each one of them. For more details Contact us."<a href="tel://8956167195 " > &nbsp;&nbsp;<i class="fa fa-mobile" aria-hidden="true"></i> +91 8956167195</a></marquee>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
                <Whyedu />
                <section class="course-about-instructor bg-secondary " id="course-about-instructor">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>About the Organization</h3>
                            <br />
                            <img alt="ISI" src="/assets/images/isi-black.svg" />
                            <br /><br />
                            <p align="justify">It is a Central Government institute, devoted to research, teaching & application of
                            not only statistics and allied sciences, but also the natural sciences, social
                            sciences and their interface with the statistics. Founded by Professor P.C.
                            Mahalanobis in Kolkata on 17th December, 1931, the institute gained the status of
                            an Institution of National Importance by an act of the Indian Parliament in 1959.
                                 </p>
                            <br />
                            <p align="justify">ISI Pune is a unit of Indian Statistical Institute, active in Teaching, Training,
                            Research and Consulting on application of statistics, operations research & allied
                            science to solve problems of the industry across the spread and depth of the
                            industries. ISI Pune bring sanctity of statistics in the mother initiatives such as
                            TQM, TPM, Six Sigma, Quality Management, Management Systems, Business Management,
                                     Data Analytic, Data Science. </p>

                        </div>
                    </div>
                </section>
                <div class="modal fade bd-example-modal-sm" id="myModal" role="dialog" >
                    <div class="modal-dialog modal-md">
                        <div class="modal-content">
                            <div class="modal-header" >
                                <span class="close" id="close_form" data-dismiss="modal">&times;</span>
                                <br />
                            </div>
                            <div class="modal-body" >
                                <div class="panel panel-default paper-shadow box_detail" >
                                    <h5 class="text-center "> Download The Course Brochure </h5>
                                    <form method="post" class="form-row" onsubmit="return validate()">

                                        <b>Your Name</b><input class="form-control" pattern="[A-Za-z ]{1,32}" type="text"
                                            required="" autocomplete="on" name="name" id="name" />
                                        <b>Your email</b><input class="form-control" type="email" required=""
                                            autocomplete="on" name="emaill" id="emaill" />
                                        <b>Your Contact No</b><input class="form-control" pattern="[7-9]{1}[0-9]{9}"
                                            type="tel" required="" autocomplete="on" name="contactt" id="contactt" />
                                        <input type="hidden" name="id" id="exd-course-name" value='<?php echo $words[0]; ?>' />
                                        <input type="hidden" id="backurl" value="<?php echo $backurl?>" />
                                        <br />
                                        <div>
                                            <div class="form-group">
                                                <div id="recaptcha" class="g-recaptcha"
                                                    data-sitekey="6Lejh30UAAAAAPhZirvpXtobtIE80K7NUzsDqKjE"></div>
                                                <div id="captcha"></div>
                                            </div>
                                        </div>
                                        <div class="mob_cb" >
                                            <div>
                                            </div><br />
                                            <button class="btn_1 rounded" type="button" onclick="getbroucher(<?php echo '\''.$filepath.'\'';?>)" id="exd-download" ><i class="icon-download"></i> Brochure</button></div>
                                        <br />
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        );
    }
}

export default Leansix;